import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingCourseSection } from 'app/_models/training/training-course-section.model';
import { TrainingCourseSectionState } from 'app/_models/training/training-course-section-state';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'training-video',
  templateUrl: './training-video.component.html',
})
export class TrainingVideoComponent implements OnInit {
  @Input() sectionData: TrainingCourseSection;
  @Input() backLink: string[];
  @Input() userCourseType: string;
  @Output() onSubmitSection = new EventEmitter<any>();
  @Output() onGoToNextSection = new EventEmitter<any>();

  public canProceed = false;
  public isComplete = false;

  constructor(
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.isComplete = this.sectionData.sectionStatus === TrainingCourseSectionState.Completed;
  }

  public submit() {
    this.notificationService.notify('success', 'Success', 'Section complete');

    this.onSubmitSection.emit();
  }
}
